import React from 'react';
import { ChevronLeft, ChevronRight, ChevronDown } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';

const pageList = (page, pages) => {
  if (pages <= 7) return Array.from({ length: pages }, (_, i) => i + 1);
  const set = new Set([1, pages, page - 1, page, page + 1].filter(p => p >= 1 && p <= pages));
  const out = [];
  [...set].sort((a, b) => a - b).forEach((p, i, arr) => { if (i && p - arr[i - 1] > 1) out.push('…'); out.push(p); });
  return out;
};

export const LibraryPagination = ({ list, testPrefix, perPageOptions = [9, 12, 24] }) => {
  const { lang, isRTL } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const Prev = isRTL ? ChevronRight : ChevronLeft;
  const Next = isRTL ? ChevronLeft : ChevronRight;
  const go = (p) => {
    list.setPage(p);
    const el = document.getElementById(`${testPrefix}-list-top`);
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 96, behavior: 'smooth' });
  };
  const nav = 'w-10 h-10 rounded-xl flex items-center justify-center text-sm font-bold transition-colors';
  return (
    <div data-testid={`${testPrefix}-pagination`} className="mt-10 flex flex-col-reverse sm:flex-row items-center justify-between gap-4">
      <span className="hidden sm:block w-[150px]" />
      <div className="flex items-center gap-1.5">
        <button type="button" data-testid={`${testPrefix}-page-prev`} disabled={list.page === 1} onClick={() => go(list.page - 1)} className={`${nav} text-slate-500 hover:bg-slate-100 disabled:opacity-30`} aria-label={L('السابق', 'Previous')}><Prev className="w-4 h-4" /></button>
        {pageList(list.page, list.pages).map((p, i) => p === '…'
          ? <span key={`e${i}`} className="w-6 text-center text-slate-400">…</span>
          : <button type="button" key={p} data-testid={`${testPrefix}-page-${p}`} onClick={() => go(p)}
              className={`${nav} ${p === list.page ? 'bg-blue-600 text-white shadow-md shadow-blue-600/25' : 'text-slate-600 hover:bg-slate-100'}`}>{p}</button>)}
        <button type="button" data-testid={`${testPrefix}-page-next`} disabled={list.page === list.pages} onClick={() => go(list.page + 1)} className={`${nav} text-slate-500 hover:bg-slate-100 disabled:opacity-30`} aria-label={L('التالي', 'Next')}><Next className="w-4 h-4" /></button>
      </div>
      <label className="relative flex items-center h-11 rounded-xl bg-white border border-slate-200 ps-4 pe-9 text-sm text-slate-600">
        <select data-testid={`${testPrefix}-per-page`} value={list.perPage} onChange={(e) => list.setPerPage(Number(e.target.value))} className="appearance-none bg-transparent outline-none cursor-pointer font-semibold">
          {perPageOptions.map(n => <option key={n} value={n}>{L(`عرض ${n} في الصفحة`, `Show ${n} per page`)}</option>)}
        </select>
        <ChevronDown className="absolute end-3 w-4 h-4 text-slate-400 pointer-events-none" />
      </label>
    </div>
  );
};
